import type { Tonart, AccidentalType } from '../types'

export const DUR_TONARTEN: Tonart[] = [
  { name: 'C',  fifths:  0, accidentals: 0, accidentalType: 'none',  tonicMidi: 60, mode: 'dur' },
  { name: 'G',  fifths:  1, accidentals: 1, accidentalType: 'sharp', tonicMidi: 67, mode: 'dur' },
  { name: 'D',  fifths:  2, accidentals: 2, accidentalType: 'sharp', tonicMidi: 62, mode: 'dur' },
  { name: 'A',  fifths:  3, accidentals: 3, accidentalType: 'sharp', tonicMidi: 69, mode: 'dur' },
  { name: 'E',  fifths:  4, accidentals: 4, accidentalType: 'sharp', tonicMidi: 64, mode: 'dur' },
  { name: 'H',  fifths:  5, accidentals: 5, accidentalType: 'sharp', tonicMidi: 71, mode: 'dur' },
  { name: 'F♯', fifths:  6, accidentals: 6, accidentalType: 'sharp', tonicMidi: 66, mode: 'dur' },
  { name: 'Des', fifths: -5, accidentals: 5, accidentalType: 'flat', tonicMidi: 61, mode: 'dur' },
  { name: 'As', fifths: -4, accidentals: 4, accidentalType: 'flat',  tonicMidi: 68, mode: 'dur' },
  { name: 'Es', fifths: -3, accidentals: 3, accidentalType: 'flat',  tonicMidi: 63, mode: 'dur' },
  { name: 'B',  fifths: -2, accidentals: 2, accidentalType: 'flat',  tonicMidi: 70, mode: 'dur' },
  { name: 'F',  fifths: -1, accidentals: 1, accidentalType: 'flat',  tonicMidi: 65, mode: 'dur' },
]

export const KREUZ_REIHENFOLGE = ['Fis', 'Cis', 'Gis', 'Dis', 'Ais', 'Eis', 'His']
export const B_REIHENFOLGE     = ['B', 'Es', 'As', 'Des', 'Ges', 'Ces', 'Fes']

const DUR_INTERVALLE = [0, 2, 4, 5, 7, 9, 11]

export function tonleiterMidi(tonart: Tonart): number[] {
  return DUR_INTERVALLE.map(iv => tonart.tonicMidi + iv).concat(tonart.tonicMidi + 12)
}

export function dreiklangMidi(tonart: Tonart): number[] {
  return [tonart.tonicMidi, tonart.tonicMidi + 4, tonart.tonicMidi + 7]
}

export function findeTonart(name: string): Tonart | undefined {
  return DUR_TONARTEN.find(t => t.name === name)
}

export function dominante(tonart: Tonart): Tonart {
  const ziel = ((tonart.fifths + 1 + 18) % 12) - 6
  return DUR_TONARTEN.find(t => t.fifths === ziel) ?? tonart
}

export function subdominante(tonart: Tonart): Tonart {
  const ziel = ((tonart.fifths - 1 + 18) % 12) - 6
  return DUR_TONARTEN.find(t => t.fifths === ziel) ?? tonart
}

const NOTE_DEUTSCH = ['C', 'Des', 'D', 'Es', 'E', 'F', 'Fis', 'G', 'As', 'A', 'B', 'H']

export function midiZuNotenName(midi: number): string {
  return NOTE_DEUTSCH[midi % 12]
}

export function tonartTonNamen(tonart: Tonart): string[] {
  return tonleiterMidi(tonart).slice(0, 7).map(midiZuNotenName)
}

export function vorzeichenText(tonart: Tonart): string {
  if (tonart.accidentals === 0) return 'keine Vorzeichen'
  const symbol = tonart.accidentalType === 'sharp' ? '♯' : '♭'
  const wort   = tonart.accidentalType === 'sharp' ? 'Kreuz' : 'B'
  const plural = tonart.accidentals === 1 ? wort : wort + (wort === 'Kreuz' ? 'e' : 's')
  return `${tonart.accidentals} ${plural} (${symbol})`
}

export function tonartenMitVorzeichen(accidentals: number, typ: AccidentalType): Tonart[] {
  if (accidentals === 0) return DUR_TONARTEN.filter(t => t.accidentals === 0)
  return DUR_TONARTEN.filter(t => t.accidentals === accidentals && t.accidentalType === typ)
}
